import React from 'react'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import { ModalDescription } from '../../../../Components/Modal/ModalDescription'
import AddStateForm from './AddStateForm'

const AddStateModal = ({
  modalShow,
  handleClose,
  handleSave,
  statesForUS,
  isLoading,
}) => {
  return (
    <Modal show={modalShow}>
      <ModalHeader>
        <ModalTitle>Import Tax Exemption Document</ModalTitle>
        <ModalDescription>
          Select state and upload your document
        </ModalDescription>
      </ModalHeader>
      <ModalBody>
        <AddStateForm
          handleClose={handleClose}
          handleSave={handleSave}
          statesForUS={statesForUS}
          isLoading={isLoading}
        />
      </ModalBody>
    </Modal>
  )
}

export default AddStateModal
